import React from 'react'
import { OurAppsBreadcrumbBar } from '../../../our-apps-breadcrumb-bar'
import CallToActionSection from '../../../call-to-action-section'
import { FeatureSection } from './feature-section'
import { AboutSection } from './about-section'
import { PlatformSection } from './platform-section'
import { HaulerNextProductImage } from '../../../product-image/hauler-next-product-image'

export default function HaulerNext() {
  return (
    <>
      <OurAppsBreadcrumbBar title="Hauler Next" productImage={<HaulerNextProductImage />} />
      <AboutSection />
      <PlatformSection />
      <FeatureSection />
      <CallToActionSection />
    </>
  )
}
